/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * English resource file
 */
export const labels = {
	title: 'EY Canvas Economics',
	status: 'Status',
	header: 'Header',
	canvas: 'Canvas',
	canvasEconomics: 'Canvas Economics',
	badRequest: 'bad request',
	errorBanner: '{0} Error(s)',
	userProfileDropdown: {
		myProfile: 'My Profile',
		signOut: 'Sign Out'
	},
	clientCode: 'Client code',
	hours: 'Hours',
	local: 'Local',
	currency: 'Currencies',
	rate: 'Rate',
	forecast: 'Forecast',
	variance: 'Variance',
	edit: 'Edit',
	arrowUp: 'Arrow UP',
	budget: 'Budget',
	priorBudget: 'Prior Budget',
	currentBudget: 'Current Budget',
	summary: 'Summary',
	actual: 'Actual',
	priorActual: 'Prior Actual',
	currentActual: 'Current Actual',
	remaining: 'Remaining',
	adjustment: 'Adjustment',
	estimate: 'Estimate',
	isRequired: '{0} is required',
	isPositiveInteger: '{0} is required and must be non-negative integer number.',
	isPositiveDecimal: '{0} is required and must be a positive number with 2 decimal places.',
	in: 'In',
	id: 'ID',
	currentYear: 'Current Year',
	priorYear: 'Prior Year',
	budgetHierarchy: 'Budget hierarchy',
	executionBudgetHierarchy: 'Execution budget hierarchy',
	noContentAvailable: 'No content available',
	viewMore: 'View More',
	budgetExecutionPhase: 'Budget for all objects within {0}',
	details: 'details',
	unallocated: 'Unallocated',
	none: 'None',
	thousands: 'Thousands',
	millions: 'Millions',
	lakhs: 'Lakhs',
	crores: 'Crores',
	budgetObjectName: 'Budget Object Name',
	editActivityCodes: 'Edit activity codes',
	save: 'Save',
	send: 'Send',
	cancel: 'Cancel',
	searchActivityCodes: 'Search Activity Codes',
	noActivityCodesAvailable: 'No activity codes available',
	select: 'Select',
	engagementCode: 'Engagement code',
	engagementCodeName: 'Engagement code name',
	activityCode: 'Activity code',
	activityCodeDescription: 'Activity code description',
	searchActivityCodesPlaceholderText: 'Search activity codes',
	addMember: 'Add Member',
	closeLabel: 'Close',
	cancelLabel: 'Cancel',
	seachInputRequired: 'Search input required',
	nameOrEmail: 'Name or email',
	emailForExternal: 'Email',
	noRecord: 'No results found',
	userSearchPlaceholder: 'Enter name or email and press enter to see results.',
	userSearchPlaceholderForExternal: 'Enter email and press enter to see results.',
	clearAllValues: 'Clear all values',
	clear: 'Clear',
	inValidEmail: 'Please enter valid email',
	invalidClientCode: 'Invalid client code',
	railSearchText: 'Search',
	open: 'Open',
	remove: 'Remove',
	leave: 'Leave',
	delete: 'Delete',
	markAsCompleted: 'Mark as completed',
	budgetedHours: 'Budgeted hours',
	forecastedHours: 'Forecasted hours',
	actualHours: 'Actual hours',
	ftaVariance: 'FTA variance',
	ftaVarianceTooltip: 'Forecast to actual variance',
	usedHours: 'Used hours',
	etcHours: 'ETC hours',
	createProjectCard: 'Create Project',
	plusClients: '+{0} Clients',
	plusCodes: '+{0} Client codes ',
	clientNames: 'Client Names: ',
	clientName: 'Client Name: ',
	clientNameLabel: 'Client name',
	clientCodes: 'Client Codes: ',
	clientCodeCard: 'Client Code: ',
	financialAnalysis: 'Financial analysis',
	billingExpenses: 'Billing & expenses',
	independence: 'Independence',
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel:'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	notApplicable: 'Not applicable',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients:'No associated client',
	noCanvasEngagementsIdentified:'No EY Canvas engagements identified',
	placeholderForSearch:'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: 'Display data by',
	financialDetails: 'Financial details',
	actualHoursToDate: 'Actual hours to date',
	byWeekEndingDate: 'by week ending date',
	ClickAndDrag: 'Click and drag an area on the chart to zoom in',
	etc: 'Estimated time to complete',
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: 'Tasks & Milestones',
	milestonesOverdue: 'Milestones overdue',
	milestoneOverdue: 'milestones overdue',
	inProgress: 'In progress',
	inReview: 'In review',
	Complete: 'Complete',
	assignments: 'Assignments',
	assignment: 'assignments',
	assignmentsOverdue: 'Assignments overdue',
	assignmentOverdue: 'assignments overdue',
	overdue: 'overdue',
	requestOverdue: 'Request overdue',
	requestsOverdue: 'requests overdue',
	total: 'Total',
	complete: 'Complete',
	closed: 'Closed',
	Unassigned: 'Unassigned',
	unassigned: 'unassigned',
	sent: 'Sent',
	totalTask: 'Total Task',
	collaboration: 'Collaboration',
	received: 'Received',
	accepted: 'Accepted',
	outstanding: 'Outstanding',
	unsentDrafts: 'Unsent drafts',
	draft: 'Draft',
	drafts: 'drafts',
	returned: 'returned',
	draftRequests: 'draft requests',
	percent: 'Percent',
	preparer : 'Preparer',
	reviewer : 'Reviewer',
	NoDataForSelectedOptions: 'No information available for the selected options.',
	NoAssignmentDataForSelectedOptions: 'Engagement is not using the Assignment feature',
	NoCollabDataForSelectedOptions: 'Engagement is not using the Collaboration feature',
	tasks: 'Tasks',
	totalTasks: 'total tasks',
	requests: 'requests',
	requestSent: 'requests sent',
	requestsSent: 'Requests sent',
	expandDetails: 'Expand details',
	onlyProjectAdministratorsCanEdit: 'Only Project Administrators can edit',
	onlyProjectAdministratorsCanDelete: 'Only Project Administrators can delete projects',
	userOptions: 'User Options',
	userOptionsDropdown: {
		userSettings: 'User settings',
		delegateAccess: 'Manage delegates',
        privacyNotice:'Privacy notice',
		signOut: 'Sign out'
	},
	delegateToInstruction: 'Delegate access to colleagues, so that they can validate engagement codes on your behalf. These delegates will be able to validate all engagements codes you have access to.',
	delegateFromInstruction: 'The following users have delegated their rights to validate engagement codes.',
	delegateAccess: 'Manage delegates',
	addDelegates: 'Add delegates',
	addAnother: 'Add new delegate',
	hideMyDelegate: 'Hide my delegates',
	showMyDelegate: 'Show my delegates',
	duplicateUser: 'Delegate already added',
	informationRequired: 'This information is required',
	delegateTo: 'Delegated to',
	delegateFrom: 'Delegated from',
	noDelegatesAdded: 'No delegates added.',
	noDelegationReceived: 'No delegation received.',
	removeDelegateMessgae: 'Are you sure that you want to remove this delegate? Once removed, they will no longer be able to validate financial engagement codes on your behalf.',
	removeDelegateTitle: 'Remove a delegate',
	delegate:'Delegate',
	saveAndClose: 'Save & close',
	resetZoom: 'Reset zoom',
	exportData: 'Export data',
	rankCode: 'Rank code',
	userGui: 'User GUI',
	email: 'Email',
	globalAnsr: 'Global ANSR',
	globalCost: 'Global cost',
	globalMargin: 'Global margin',
	localAnsr: 'Local ANSR',
	localCost: 'Local cost',
	localMargin: 'Local margin',
	weekEnding: 'Week ending',
	welcomeToEconomics: 'Welcome to the EY Canvas Economics ',
	adminPortal: 'administrative portal',
	home: 'Home',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	addBtn: 'Add',
	cancelBtn: 'Cancel',
	close: 'Close',
	selectRole: 'Role',
	upsText: 'Ups!',
	sufficientRightsToAccess: 'You do not have sufficient rights to access this page',
	detailedInformation : 'Detailed information may vary from summary data presented due to timing differences of when data is made available.',
	noResultFound: 'No results match the search criteria',
	loading: 'Loading...',
	search: 'Search',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg:
		'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',
		
	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: 'Expand',
    collapse: 'Collapse',
	bulkSendIndependenceLabel: 'Bulk send independence confirmation',
	independenceStatusInviteUserLabel: 'Add internal team member as Independence only',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
	clickToInviteUser: 'to send independence confirmation',
	click: 'Click',
	invitePending:'Invite pending',
	engagementRolePlaceholder: 'Engagement role',
	engagementRoleRequiredErrorMessage: 'Please select the engagement role for the selected team member',
	engagementInvitationSuccessToastMessage: 'You have successfully sent the independence confirmation(s).',
	engagementInvitationFailureToastMessage: 'Failed to send the independence confirmation(s), Please retry. If issue persists, reach out to the Help desk.',
	independenceInviteConfirmationMessage: 'Independence confirmation has been sent. Response is pending.',
	engagementRoleRequiredOverAllErrorMessage: 'An engagement role has not been selected for one or more users. Select the engagement role from the drop down to proceed with sending the Independence confirmation.',
	administrativeContractor: 'Administrative Contractor'
};

export const errors = {
	default: 'An error occurred. Please contact helpdesk.',
	102: 'Invalid Project.',
	106: 'RBAC authorization denied.',

	1001: 'User not found.',
	1002: 'User GetAll call failed.',
	1003: 'User GUI can not be null.',
	1004: 'Request can not be null.',
	1005: "User couldn't be created because a user with the same GUI already exists.",
	1006: 'More than one user with the same GUI was found.',
	1007: 'The user is not active. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1008: 'The selected number format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1009: 'The selected rounding format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1010: 'The selected currency format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1011: 'The selected date format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1012: 'The selected language is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1013: 'The first name is either too short or too long. Please try again.',
	1014: 'The last name is either too short or too long. Please try again.',
	1015: 'The selected negative number format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1016: "The User couldn't be updated because it doesn't exist.",
	1017: 'An error has occured while getting the user preferences. The API Call has failed.',
	1018: 'An error has occured while creating the user. The API Call has failed.',
	1019: 'An error has occured while updating the user preferences. The API Call has failed.',
	1020: 'User is not active. Refresh the page and try again. If the error persists, contact the Help Desk.',
	1021: 'The selected theme value is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1022: 'The selected currency value is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.',
	1023: 'User is not authorized to remove requested team member from project.',
	1024: 'An error has occured while creating the delegate user. The API Call has failed.',
	1025: 'Delegate users list must not be empty.',
	1026: 'A user\'s name is either too long or too short.',
	1027: 'A user\'s GUI is invalid.',
	1028: 'A user\'s email address is either too long or too short.',
	1029: 'User Id must not be empty.',
	1030: 'User name must not be empty.',
	1031: 'User email address must not be empty.',
	1032: 'User is not part of delegate to collection to remove access.',
	1033: 'User is not part of delegate from collection to remove access.',
	1034: 'User is already part of delegate to collection.',
	1035: 'User Id length is not appropriate. Please try again with correct User Id.',
	1036: 'Logged in user can not be part of list. Please try again later.',
	1040: 'You do not have administrator rights. Please contact the help desk.',

	7001: 'Engagements metadata call failed.',
	7006: 'EY Canvas is not accessible at this time. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	8003: 'Error while getting Engagement Details from CDS API.',
	8006: 'EY Canvas is not accessible at this time. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	8004: 'Engagement code not found. If this is a Mercury code, ensure that the Engagement Type was included.  Try again and if the issue persists, contact the Help Desk.',
	8007: 'Error while getting Engagement Details from CDS API.',
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: 'Request cannot be null',
	9002: 'Project Client Code field cannot be null',
	9003: 'Project Name field cannot be null.',
	9004: 'Percentage field cannot be null.',
	9005: 'Rate field cannot be null.',
	9006: 'The budget does not have any selected engagement associated.',
	9007: 'Engagement unique identifier cannot be null.',
	9008: 'Engagement client name cannot be null.',
	9009: 'Engagement description cannot be null.',
	9010: 'Engagement client unique identifier cannot be null.',
	9011: 'Related engagement system cannot be null.',
	9012: 'Related engagement unique identifier cannot be null.',
	9013: 'Related engagement name cannot be null.',
	9014: 'Related engagement client unique identifier cannot be null.',
	9015: 'Related engagement client name cannot be null.',
	9016: 'Related engagement added by cannot be null.',
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: 'One or more Related engagement Codes are invalid.',
	9019: "Project's percentage should be greater than zero.",
	9020: "Project's percentage should not have more than two decimal digits.",
	9021: "Project's rate should be greater than zero.",
	9022: 'ProjectId is invalid.',
	9023: 'Get call for financial analysis failed.',
	9024: 'Project Details Not Found.',
	9025: 'Get call for header failed.',
	9026: 'No results match the search criteria.',
	9027: 'Invalid aggregation type.',
	9028: 'The current user does not have access to the project.',
	9029: 'Project billing details not found.',
	9030: "Project Financial Filters not found.",
	9031: "A user's name is either too long or too short.",
	9032: "A user's GUI is invalid.",
	9033: "A user's email address is either too long or too short.",
	9034: 'At least one team member should have project administrator role.',
	9035: 'You are the last active project administrator user of the project. Delete the project to remove it from your Landing Page. If you are unable to delete the project, contact the Help Desk.',
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: 'Please remove some team members because the quantity exceeds the {0}.',
	9038: 'Please remove some Engagement codes because the quantity exceeds the {0}.',
	9039: 'Project users count must be greater than zero.',
	9040: 'Unvalidated Financial Codes must not be null or empty strings, and their length cannot surpass 50 characters.',
	9041: 'Project id must not be empty.',
	9042: 'Unable to complete deletion. Try again and if the error persists, contact the Help Desk.',
	9043: 'The current user does not have access to edit a project.',
	9044: 'Project Financial Details call failed.',
	9045: 'Project status is not valid.',
	9046: 'Project user status is not valid.',
	9047: 'Invalid project user role.',
	9048: 'Project name should be within 500 characters.',
	9049: 'Project user first name cannot be empty.',
	9050: 'Project user last name cannot be empty.',
	9051: 'Project user GUI cannot be empty.',
	9052: 'Project user email cannot be empty.',
	9053: 'Project user admin flag cannot be empty.',
	9054: 'Priviledged account cannot be added as project user.',
	9055: 'Project Expense Filters not found.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Financial codes is invalid.',
	9063: 'Independence complete has invalid rationale value.',
	9064: 'Independence complete type has invalid value.',
	9065: 'Project Expense Filters not found.',
	9066: 'Number of engagement ids linked to the project is greater than the maximum allowed number.',
	9067: 'Invalid patch operation.',
	9068: 'Some user already updated the status, refresh the page to view the latest status.',
	9069: 'Independence patch API failed.',
	9070: 'Duplicate financial codes associated to canvas engagement.',
	9071: 'Only single financial codes associated to canvas engagement can be marked as primary code.',
	9072: 'Primary financial codes associated to canvas engagements is invalid.',
	9073: 'Duplicate unvalidated financial codes.',
	9074: 'Duplicate users.',
	9075: 'A user Email is invalid.',
	9076: 'Engagement user creater request body cannot be empty.',
	9077: 'Engagement user create request has duplicate users.',
	9078: 'Engagement user role is invalid.',
	9079: 'Invalid canvas engagement.',
	9080: 'Engagement not mapped to project.',
	9081: 'Engagement user creation request failed.',
	9082: 'Session has been timed out due to inactivity. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Admin error codes*/
	14001: 'User not found',
	14002: 'Admin User call failed',
	14003: 'Admin user found is InActive',
	14004: 'Admin user creation failed',
	14005: 'The first name is either too short or too long. Please try again',
	14006: 'The last name is either too short or too long. Please try again',
	14007: 'Administrator role id is invalid',
	14008: 'The selected user is already an administrator. Please review.',
	14009: 'Admin user search call failed',
	14010: 'User gui cannot be empty',
	14011: 'User gui must be greater than zero',
	14012: 'User id is not valid. Please try again',
	14013: 'Email address is not valid. Please try again',
	14014: 'Logged in user is not same as admin user',
	14015: 'Admin project search call failed',
	14016: 'Admin user already exists but is InActive',
	14017: 'Admin can only be priviledged user account',
	14018: 'Administrator role id cannot be empty.',
	14019: 'Logged in user is not system admin.',
	14020: 'Invaid requestor privileged account.',
	14021: 'Admin can only be priviledged user account.',
	14023: 'Error removing existing admin roles.',
	14024: 'Error adding updated admin roles.',
	14025: 'Admin user id cannot be empty.',

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};
export const roundingOptions = [
	{value: 'none', label: 'none' },
	{value: 'thousands', label: 'In thousands' },
	{ value: 'millions', label: 'In millions' },
	{ value: 'lakhs', label: 'In lakhs' },
	{ value: 'crores', label: 'In crores' }
];

export const displayLanguages = [
	{ displayLanguageId: 1, label: 'English', value: 'en-us' },
	{ displayLanguageId: 4, label: 'Français', value: 'fr-ca' },
	{ displayLanguageId: 5, label: 'Español', value: 'es' },
	{ displayLanguageId: 7, label: 'Português', value: 'pt-br' },
	{ displayLanguageId: 8, label: 'Japanese', value: 'ja' },
	{ displayLanguageId: 9, label: 'Chinesezh-cn', value: 'zh-cn' },
	{ displayLanguageId: 10, label: 'Chinesezh-tw', value: 'zh-tw' },
	{ displayLanguageId: 11, label: 'Hebrew', value: 'he' },
	{ displayLanguageId: 12, label: 'Korean', value: 'ko' },
];

export const numberFormats = [
	{ value: '1,234,567,890', label: 'numbericStlye1', title: '1,234,567,890' },
	{ value: '1.234.567.890', label: 'numbericStlye3', title: '1.234.567.890' },
	{ value: '1,23,45,67,890', label: 'numbericStlye7', title: '1,23,45,67,890' },
	{ value: '1 234 567 890', label: 'numbericStlye2', title: '1 234 567 890' }
];

export const dateFormats = [
	{ value: 'MM/dd/yyyy', label: 'MM/DD/YYYY' },
	{ value: 'dd/MM/yyyy', label: 'DD/MM/YYYY' },
	{ value: 'yyyy/MM/dd', label: 'YYYY/MM/DD' }
];

export const negativeNumberFormats = [
	{ value: '(1.1)', label: '(1.1)' },
	{ value: '-1.1', label: '-1.1' },
	{ value: '- 1.1', label: '- 1.1' },
	{ value: '1.1-', label: '1.1-' },
	{ value: '1.1 -', label: '1.1 -' }
];

export const currencyFormats = [
	{ value: 'global', label: 'Global' },
	{ value: 'local', label: 'Local' }
];

export const themeOptions = {
	light: 'Light',
	dark: 'Dark'
};

export const currencyOptions = {
	global: 'Global',
	local: 'Local'
};

export const currencyDisplayOptions = [
	{ value: 'Global', label: 'Global' },
	{ value: 'Local', label: 'Local' }
];

export const statusValues = [
	{ isActive: true, label: 'Active' },
	{ isActive: false, label: 'Inactive' }
];

export const financialOptions = {
	serviceLine: 'Service line',
	subServiceLine: 'Sub-service line',
	teamMember: 'Team member',
	rank: 'Rank'
};

export const roles = {
	1: 'Partner in Charge',
	2: 'Engagement Partner',
	3: 'Executive Director',
	4: 'Principal',
	5: 'Senior Manager',
	6: 'Manager',
	7: 'Senior',
	8: 'Staff',
	9: 'Intern',
	10: 'Engagement Quality Reviewer',
	11: 'Other Partner',
	12: 'GDS - Staff',
	13: 'Advisory (ITRA,TAS,Human Capital or Other)',
	14: 'Tax',
	15: 'Executive Support Services',
	16: 'General Counsel',
	17: 'Audit Quality Reviewer',
	21: 'Internal Audit Supervisor',
	22: 'Internal Audit Staff',
	23: 'Regulator',
	24: 'Other (e.g. due diligence review)',
	25: 'Office',
	26: 'Area',
	27: 'Industry',
	28: 'National',
	29: 'Global',
	30: 'GDS - Senior',
	31: 'GDS - Manager'
};

export const serviceLines = [
	{ value: 0, label: 'All service lines' },
	{ value: 1, label: 'Advisory' },
	{ value: 2, label: 'Assurance' },
	{ value: 3, label: 'GCO' },
	{ value: 4, label: 'TAS' },
	{ value: 5, label: 'Tax' },
	{ value: 6, label: 'Other' }
];

export const serviceLinesByServiceLineCode = [
	{ code: 'Not available', label: 'Not available' },
	{ code: 'ASU', label: 'Assurance' },
	{ code: 'TAS', label: 'Strategy and Transactions' },
	{ code: 'TAX', label: 'Tax' },
	{ code: 'ADV', label: 'Consulting' },
];

export const userRanks = [
	{ id: '11', name: 'Partner' },
	{ id: '12', name: 'Partner' },
	{ id: '13', name: 'Executive Director' },
	{ id: '21', name: 'Sr. Manager' },
	{ id: '32', name: 'Manager' },
	{ id: '36', name: 'Tax Manager' },
	{ id: '4', name: 'Contractor' },
	{ id: '41', name: 'Senior 3' },
	{ id: '42', name: 'Senior' },
	{ id: '43', name: 'Staff 2' },
	{ id: '44', name: 'Staff' },
	{ id: '45', name: 'Senior 2' },
	{ id: '46', name: 'Staff 3' },
	{ id: '49', name: 'Associate' },
	{ id: '5', name: 'Admin Contractor' },
	{ id: '51', name: 'Intern' },
	{ id: '52', name: 'Admin Support' },
	{ id: '53', name: 'Intern (CBS)' },
	{ id: '55', name: 'Admin Lead' },
	{ id: '56', name: 'Admin Advanced' },
	{ id: '57', name: 'Admin Intermediate' },
	{ id: '58', name: 'Admin Entry' },
	{ id: '61', name: 'Director' },
	{ id: '62', name: 'Associate Director' },
	{ id: '63', name: 'Assistant Director' },
	{ id: '64', name: 'Supervising Associate' },
	{ id: '65', name: 'Sr. Associate' },
	{ id: '66', name: 'Associate' },
	{ id: 'Not available', name: 'Not available' },
];

export const financialAnalysis = {
	noResultFound: 'No results found for the selected options',
	allServiceLines: 'All service lines',
	allSubServiceLines: 'All Sub Service lines',
	allMembers: 'All members',
	allAvailable: 'All available',
	allAdded: 'All added',
	selectAll: 'Select all',
	noResult: 'No results found',
	noneSelected: 'None selected',
	clearAllSeleted: 'Clear # selected',
	showSelected: 'Show selected',
	allRanks: 'All ranks'
};

export const independenceStatus = [
	{ value: 1, label: 'Incomplete - Not invited' },
	{ value: 2, label: 'Incomplete - In progress' },
	{ value: 3, label: 'Completed - Other'},
	{ value: 4, label: 'Completed - Validated In EY Canvas'}
];

export const eycanvasIndependenceStatus = [
	{ value: 1, label: 'Incomplete' },
	{ value: 2, label: 'No Matters Identified' },
	{ value: 3, label: 'Matter Identified - Pending Action' },
	{ value: 4, label: 'Matter Resolved - Denied Access' },
	{ value: 5, label: 'Matter Resolved - Granted Access' },
	{ value: 6, label: 'Not Applicable' },
	{ value: 7, label: 'Restored' },
	{ value: 8, label: 'Override' },
	{ value: 9, label: 'Prior - No Matters Identified' },
	{ value: 10, label: 'Prior - Matter Identified - Pending Action' },
	{ value: 11, label: 'Prior - Matter Resolved - Granted Access' },
	{ value: 12, label: 'Prior - Matter Resolved - Denied Access' }
];

export const availableUserRoles = [
  { value: 1, label: 'Partner in Charge', displayOrder: 9 },
  { value: 2, label: 'Engagement Partner', displayOrder: 8 },
  { value: 3, label: 'Executive Director', displayOrder: 5 },
  { value: 4, label: 'Principal', displayOrder: 6 },
  { value: 5, label: 'Senior Manager', displayOrder: 4 },
  { value: 6, label: 'Manager', displayOrder: 3 },
  { value: 7, label: 'Senior', displayOrder: 2 },
  { value: 8, label: 'Staff', displayOrder: 1 },
  { value: 10, label: 'Engagement Quality Reviewer', displayOrder: 10 },
  { value: 11, label: 'Other Partner', displayOrder: 7 },
  { value: 12, label: 'GDS - Staff', displayOrder: 13 },
  { value: 16, label: 'General Counsel', displayOrder: 12 },
  { value: 17, label: 'Audit Quality Reviewer', displayOrder: 11 },
  { value: 30, label: 'GDS - Senior', displayOrder: 14 },
  { value: 31, label: 'GDS - Manager', displayOrder: 15 }
]

export const employmentStatus = [
	{ value: 'A', label: 'Active' },
	{ value: 'D', label: 'Terminated' },
	{ value: 'L', label: 'Leave of Absence' },
	{ value: 'T', label: 'Terminated' },
	{ value: 'P', label: 'Leave of Absence' },
	{ value: 'R', label: 'Terminated' },
	{ value: 'U', label: 'Leave of Absence' },
]

export const independenceStatusDropdown = [
	{
		label: 'Incomplete',
		options: [
			{ value: 1, label: 'Incomplete - Not invited' },
			{ value: 2, label: 'Incomplete - In progress' }
		]
	},
	{
		label: 'Complete',
		options: [
			{ value: 3, label: 'Completed - Other'}
		]
	}
];

export const customizedTableOptions = [
	{id: 2, label: 'EY Canvas independence status'},
	{id: 3, label: 'Member firm'},
	{id: 4, label: 'Country'},
	{id: 5, label: 'Hours charged'},
	{id: 6, label: 'Overall independence status'},
	{id: 7, label: 'Confirmation date'},
	{id: 8, label: 'Employment Status'},
	{id: 9, label: 'Updated by'},
	{id: 10, label: 'Updated date'}
];

export const independenceStatusChangeReasons = [
    { value: 1, label: 'Completed outside of EY Canvas - No Matters Identified', isDisplayed: true},
	{ value: 7, label: 'Completed outside of EY Canvas - Matters Identified', isDisplayed: true},
    { value: 8, label: 'Completed outside of EY Canvas - Matters Resolved', isDisplayed: true},
	{ value: 2, label: 'Always a covered person', isDisplayed: true },
	{ value: 3, label: 'No longer with the Firm', isDisplayed: true},
	{ value: 4, label: 'Leave of absence', isDisplayed: true},
	{ value: 5, label: 'Terminated', isDisplayed: false},
	{ value: 6, label: 'Other', isDisplayed: false}
];

export const common = {
	selected: 'Selected',
	cancel: 'Cancel',
	checkbox: {
		selectAllOn: 'Select all',
		selectAllOff: 'Unselect all'
	},
	clear: 'Clear',
	close: 'Close',
	nav: {
		projectName: 'Project name'
	},
	pagination: {
		show: 'Show',
		iconHover: {
			first: 'First Page',
			previous: 'Previous Page',
			next: 'Next Page',
			last: 'Last Page'
		}
	},
	search: {
		clear: 'Clear search',
		buttonTitle: 'Search',
		placeholder: 'Search',
		noResultsPlaceholder: 'No results found'
	},
	table: {
		remove: 'Remove',
		noDataPlaceholder: 'No data available',
		noResultsPlaceholder: 'No results found'
	},
	toggleSwitch: {
		no: 'No',
		yes: 'Yes'
	},
	wizard: {
		next: 'Continue',
		back: 'Back',
		finish: 'Finish'
	},
	unsavedChanges: 'Unsaved changes',
	unsavedChangesDescription: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to undo your changes?'
};

export const project = {
	myProjects: 'My projects',
	priorProjects: 'Prior Projects',
	searchForBudgets: 'Search',
	emptyContainer: 'You do not have any active budget.  Click "Create budget" to get started.',
	noResultsFound: 'No results found.',
	create: {
		title: 'Create project',
		clientCode: 'Client code',
		clientCodeInfo: 'Mirror codes are not recognized. Use the code from the system that issued the code (i.e., Mercury or GFIS).',
		clientName: 'Client name',
		clientNamePlaceholder: 'Enter client code to look up client name',
		name: 'Project name',
		rate: 'Default rate per hour',
		rateInfo: 'The default rate per hour will be used to calculate the value of budgeted hours. This rate should be calculated as the fees to be bills divided by total expected hours.',
		percentage: 'Expected realization percentage',
		percentageInfo: 'The expected realization percentage will be applied to the time value of hours charged in Mercury or GFIS.',
		relateEngagementsInstructionalText: 'Select one or more EY Canvas engagements that will be used in this project.  Metrics from these engagements will be presented alongside financial data.  Only engagements currently accessible will be displayed.',
		selectClientAndWorkspaceInstructionalText: 'Select a client and workspace to identify EY Canvas engagements that will be related to this project.',
		engagementPanelPlaceholder: 'Select a client and workspace to show suggested engagements.',
		engagementPanelNoResultsFound: 'No results found',
		emptyEngagements: 'No EY Canvas engagements available. Create a new engagement in EY Canvas to get started.',
		selectClient: 'Select client',
		selectWorkspace: 'Select workspace',
		selectEngagements: 'Select engagement',
		selectedEngagements: 'Added engagements',
		selectedEngagementError: 'Select one or more engagements to continue',
		searchEngagements: 'Search engagements',
		searchUsers: 'Search users',
		engagementLabel: '{0} | ID: {1}',
		addBtn: 'Add',
		removeBtn: 'Remove',
		clientLbl: 'Client',
		engagementCodeLbl: 'Engagement code',
		engagementTypeCodeLbl: 'Engagement type',
		engagementNameLbl: 'Engagement name',
		engagementId: 'ID',
		addedByLbl: 'Added By',
		engagementDescriptionLbl: 'Engagement description',
		systemLbl: 'System',
		noEngagementsLabel: 'Relate Engagement codes to this project.',
		step4InstTxt: 'Select one or more engagement codes to be associated to the project.',
		relatedEngagementCodesSubtitle: 'Related Engagement Codes',
		relatedEngagementCodeLink: 'Relate engagement code from Mercury or GFIS. Mirror codes are not recognized.',
		unauthorizedModalHeader: 'Unauthorized user',
		unauthorizedText: 'You are not authorized to relate',
		allowedUsersText: 'Following is a list of individuals who can take this action.',
		closeBtn: 'Close',
		validateBtn: 'Validate',
		relatedEngagementAddLabel: 'Relate engagement code from from Mercury or GFIS. Mirror codes are not recognized.',
		todayLbl: 'Today',
		NoEmailMessage: 'No email provided',
		noEngagementsAdded: 'No engagements added',
		selectToImport: 'Select an EY Canvas engagement to import users to this project.',
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: 'Added members',
		employeeName: 'Member',
		role: 'Role',
		manageTeamInstructionalText: 'Select active team members from the related EY Canvas engagements, follow the description below to add other team members not part of the EY Canvas engagements.',
		currentUser: 'Current user',
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [
			{
				stepName: 'Step 1',
				stepDescription: 'Enter project details',
				active: true
			},
			{
				stepName: 'Step 2',
				stepDescription: 'Select EY Canvas engagements'
			},
			{
				stepName: 'Step 3',
				stepDescription: 'Manage access',
				relatedEngagementCodesSubtitle: 'Related Engagement Codes',
				relatedEngagementCodeLink: 'Relate engagement code from Mercury or GFIS. Mirror codes are not recognized.',
				unauthorizedModalHeader: 'Unauthorized User',
				unauthorizedText: 'You are not authorized to relate',
				allowedUsersText: 'Following are a list of individuals who can take this action.',
				close: 'Close'
			},
			{
				stepName: 'Step 4',
				stepDescription: 'Connect to Mercury/GFIS'
			},
			{
				stepName: 'Step 5',
				stepDescription: 'Associate engagement codes to EY Canvas engagements',
				isExit: true
			}
		],
		ratePerHour: 'Rate per hour',
		realizationPercentage: 'Realization percentage'
	},
	stepOne: {
		enterProjectName: 'Enter a project name to continue'
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		clientName: 'Client',
		workspace: 'Workspace',
		engagementCode: 'Engagement code',
		canvasEngagementName: 'EY Canvas Engagement',
		changes: 'Changes',
		tooltipMessages: {
			clientName: 'Client Name',
			clientCode: 'Client Code',
			engagementCode: 'Engagement Code',
			engagementDescription: 'Engagement Name',
			workspaceID: 'Workspace ID',
			workspaceDescription: 'Workspace Name'
		}
	},
	stepThree: {
		editTeamMembers: 'Edit team members to the project',
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: 'Add team members to the project',
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: 'Member',
		projectAdministrator: 'Project administrator',
		clickHere: 'click here',
		nameOrEmail: 'Name or email',
		addNewMember: 'Add',
		firstName: 'First name',
		lastName: 'Last name',
		inviteAndClose: 'Invite & close',
		inviteAndAddAnother: 'Invite & add another',
		clear: 'Clear'
	},
	stepFour: {
		engagementCode: 'Engagement code',
		clientName: 'Client',
		validation: 'Status',
		independenceOnly: 'Independence only',
		noEngagementCodes: 'No engagement codes added to the project',
		addNewMember: 'Add',
		addEngagementManually: 'Add engagement codes',
		addEngagementCodes: 'Add engagement codes',
		editEngagementCodes: 'Edit engagement codes',
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: 'For Mercury, include the engagement type prefixed to the engagement code (e.g., E-12345678)',
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: 'Enter an engagement code',
		validate: 'Validate',
		engagementCodeRequired: 'Engagement code required',
		searchNoResults: "No results found"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: 'No results found'
		},		
		canvasEngagements: {
			searchButtonTitle: 'Search',
            clearButtonTitle: 'Clear',
            noResults: 'No results found',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
            displayUnassociatedEngagements:'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: 'Delete Project',
	deleteDescription: 'Are you sure that you want to delete the project for all users?',
	deleteDescText: 'This action cannot be undone.',
	delete: 'Delete',
	cancel: 'Cancel',
	close: 'Close',
	confirm: 'Confirm',
	leaveProject: 'Leave',
	leaveDescription: 'Are you sure that you want to leave this project? It will continue to be available for your team members.',
	change: 'change',
	changes: 'changes'
};

export const users = {
	settings: {
		title: 'User settings',
		firstName: 'First name',
		lastName: 'Last name',
		displayLanguage: 'Display language',
		numberFormat: 'Number format',
		negativeNumberFormat: 'Negative number format',
		currencyFormat: 'Currency format',
		dateFormat: 'Date format',
		roundingFormat: 'Rounding format',
		save: 'Save',
		cancel: 'Cancel',
		errorMessageSelect: 'Please select a value.',
		errorMessageInput: 'Please input a valid value.',
		isRequired: ' is required.',
		preferences: 'Preferences',
		yourDelegates: 'Your delegates',
		yourDelegatesDescription: 'Users who you have granted authority to retrieve financial data for engagement codes you have access to in Mercury or GFIS',
		delegationsFromOthers: 'Delegation from others',
		delegationsFromOthersDescription: 'Users who have granted you authority to retrieve financial data for engagements they have access to in Mercury or GFIS',
		noUsersIdentified: 'No users identified',
		addADelegate: 'Add a delegate',
		theme: 'Theme',
		preferredCurrency: 'Preferred currency',
		status: 'Status'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData : 'Filter clients',
		filter: 'Filter',
		searchPlaceholder: 'Search',
		searchClearHoverText: 'Clear',
		searchHoverText: 'Search',
		unvalidated: 'Unvalidated',
		noData: 'No EY Canvas engagement associated',
		noResults: 'No results found',
		noInformationAvailable: 'No information available for the selected options.',
		independence: 'Independence',
	    noDataFound: 'No data found',
	},
	roundingType: 'Rounding: ',
	roundingFormats: {
		none: 'None',
		thousands: 'In thousands',
		millions: 'In millions',
		lakhs: 'In lakhs',
		crores: 'In crores'
	},
	updatedDateType: {
		financialDateLabel: 'Financial data',
		updatedOn: 'updated on',
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: 'TER',
			actualTER: 'Actual TER',
			billed: 'Billed',
			actualBilling: 'Actual Billing',
			totalEngagementRevenue: 'Total engagement revenue (fees + expenses)',
			forecastedTER: 'Forecasted TER'
		},
		margin: {
			margin: 'Margin',
			target: 'Target'
		},
		globalDeliveryService: {
			gds: 'GDS usage',
			globalDeliveryService: 'Global Delivery Service'
		}
	},
	currency: 'Currency: ',
	globalCurrency: 'Global',
	localCurrency: 'Local',
	noDataAvailable: 'No data available for the selected filters',
	actualHours: 'Actual Hours',
	etc: 'ETC',
	ftaVariance: 'FTA variance',
	completedTasks: 'Completed tasks',
	closedAssignments: 'Closed assignments',
	acceptedRequests: 'Accepted requests',
	gDSUsage: 'GDS usage',
	summaryHeaderPartner: 'Partner',
	summaryHeaderPpedd: 'PPEDD',
	summaryHeaderExecutive: 'Executive',
	financialProgressCard: {
		financialProgress: 'Financial progress',
		financialDetails: 'Financial details',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: 'Cost',
		hours: 'Hours',
		expandDetails: 'Expand details',
		expand: 'Expand',
		collapse: 'Collapse',
		collapseDetails: 'Collapse details',
		margin: 'Margin',
		marginPercentage: 'Margin',
		rphAcronym: 'RPH',
		cphAcronym: 'CPH',
		mphAcronym: 'MPH',
		eafAcronym: 'EAF',
		actual: 'Actual',
		budgeted: 'Budgeted',
		forecasted: 'Forecasted',
		ftaVariance: 'FTA variance',
		ftaVarianceTooltip: 'Forecast to actual variance',
		rph: 'Rate per hour',
		cph: 'Cost per hour',
		mph: 'Margin per hour',
		ansrCost: 'NSR / Cost',
		serviceLine: 'Service line',
		subServiceLine: 'Sub-service line',
		teamMember: 'Team member',
		totalAnsr: 'Total NSR',
		totalCost: 'Total Cost',
		totalHours: 'Total Hours',
		ansrLabelText: 'Net standard revenue',
		rank: 'Rank',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: 'Show',
		first: 'First',
		last: 'Last',
		previous: 'Previous',
		next: 'Next'
	},
	financialFilters: {
		serviceLine: 'Service line',
		subServiceLine: 'Sub-service line',
		rank: 'Rank',
		teamMember: 'Team member',
		showMore: 'More',
		clear: 'Clear',
		clearAll: 'Clear All',
		search: 'Search',
		noResultsPlaceholder: 'No results',
		noFiltersAvailable: 'No filters',
		yes: 'Yes',
		no: 'No',
		tooltip: 'Filter',
		expenseType: 'Expense type'
	},
	billingAndExpenses: {
		title: 'Actual billings to date',
		forecastedTer: 'Forecasted TER',
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: 'Forecasted billing',
		collected: 'Collected',
		collectedTooltip:'Collected / Billed',
		unCollected: 'Uncollected',
		unCollectedTooltip:'Uncollected / Billed',
		billed: 'Billed (Outstanding)',
		billedTooltip:'Billed / Forecasted TER',
		billedTotal: 'Billed',
		unbilled: 'Unbilled',
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: 'Engagement code',
		invoiceDate: 'Invoice date',
		currency: 'Currency',
		invoiceNumber: 'Invoice number',
		amount: 'Amount',
		noInformationPlaceholder: 'No information available for the selected options.',
		actualTer: 'Actual TER',
		actualTerTooltip: 'Actual total engagement revenue (fees + expenses)',
		actualExpenseToDate: 'Actual expenses to date',
		displayBy: 'Display data by',
		expenseType: 'Expense type',
		teamMember: 'Team member',
		totalExpenseToDate: 'Total expenses to date',
		expenseTypeColumn: 'Expense type',
		teamMemberColumn : 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: 'Service line',
		serviceLineColumn: 'Service line',
		rank: 'Rank',
		rankColumn : 'Rank'
	},
	independence: {
		teamMember: 'Team member',
		hoursCharged: 'Hours charged',
		independenceStatus: 'Overall independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status',
		employmentStatus: 'Employment status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
        confirmationDateBefore: 'Confirmation date before',
        confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		rank:'Rank',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		reason: 'Reason',
		engagementRole: 'Engagement role',
		location: 'Location',
		filter : {
			unassociatedFinancialCodes : 'Unassociated financial codes',
			unassociatedLabel : 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header:{
		hours: 'Hours',
		actualHours: 'Actual',
		forecastedHours: 'Forecasted',
		variance: 'FTA variance',
		other: 'Other',
		ppedd: 'PPEDD',
		mgrSrMgr: 'SrMgr/Mgr',
		partnerHours: 'Partner Hours',
		executiveDirector: 'Executive Director',
		seniorManager: 'Senior Manager',
		manager: 'Manager',
		senior: 'Senior',
		staff: 'Staff',
		intern: 'Intern',
		billed: 'Billed:',
		ter: 'TER:',
		forecastedTER: 'Forecasted TER:',
		margin: 'Margin',
		ansr: 'ANSR',
		cost: 'Cost',
		terSection: 'TER',
		billedSection: 'Billed',
		forecastedTERSection: 'Forecasted',
		forecastedTERSectionForHeader: 'Forecasted TER',
		completedTasks: 'Completed tasks',
		completedAssignments:'Closed assignments',
		acceptedRequests: 'Accepted requests',
		gdsUsage: 'GDS usage',
		completedTasksTooltip:'Completed',
		totalTasksTooltip:'Total',
		completedAssignmentsTooltip:'Closed',
		totalAssignmentsTooltip:'Total',
		acceptedRequestsTooltip:'Accepted',
		sentRequestsTooltip:'Sent',
		gdsHoursTooltip:'GDS',
		actualHoursTooltip:'Actual hours',
		otherTooltip: 'Other',
		otherHeaderTooltip: 'Other',
		ppeddTooltip: 'PPEDD',
		mgrSrMgrTooltip: 'SrMgr/Mgr',
		partnerHoursTooltip: 'Partner/Principal',
		executiveDirectorTooltip: 'ED/D',
		seniorManagerTooltip: 'Sr. Manager',
		managerTooltip: 'Manager',
		seniorTooltip: 'Senior',
		staffTooltip: 'Staff',
		internTooltip: 'Intern',
		varianceTooltip: 'Forecast to actual variance',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		marginTooltip: 'Margin = (ANSR - Cost) / ANSR',
		terSectionHover: 'Actual total engagement revenue (fees + expenses)',
		forecastedTERSectionHover: 'Forecasted total engagement revenue (fees + expenses)',
		billedSectionHover: 'Actual net invoice amount',
		gdsUsageHover: 'Global Delivery Service usage'
	}
};

export const exportOptions = {
	buttonText: 'Export',
	downloadCSV: 'Download CSV',
	downloadJPEG: 'Download JPEG',
	downloadPDF: 'Download PDF',
	downloadPNG: 'Download PNG',
	downloadSVG: 'Download SVG',
	downloadXLS: 'Download XLS',
	exitFullscreen: 'Exit full screen',
	viewFullscreen: 'View full screen',
	printChart: 'Print chart'
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Manage users',
	projectsTab: 'Manage projects',
	administrators: 'Manage administrators'
};

export const projectUserStatus = {
	active: 'Active',
	inactive: 'Inactive',
};

export const projectUserRoles = {
	defaultUser: 'Default user',
	projectAdministrator: 'Project administrator'
};

export const projectStatus = {
	active: 'Active',
	deleted: 'Deleted'
};

export const administratorRoles = {
	none: 'None',
	adminReader: 'Admin reader',
	adminWriter: 'Admin writer',
	superAdmin: 'Super admin'
}

export const addUser = {
	firstName: 'First name',
	lastName: 'Last name',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	selectRole: 'Role',
	userRole: 'User role',
	clear: 'Clear',
	email: 'Email',
	role: 'Role',
	cancel: 'Cancel',
	addUser: 'Add User',
	close: 'Close',
	add: 'Add',
	addAdministrator: 'Add administrator',
	error1: 'The selected user is already a part of the project. Please review.',
	error2: 'Admin can only be priviledged user account'
};

export const adminManageProjects = {
	manageProjects: 'Manage projects',
	description: 'Search for a project by entering the project ID',
	projectId: 'Project ID',
	search: 'Search',
	clearSearch: 'Clear',
	enterValidProject: 'Enter valid project ID',
	projectDetails: 'Project details',
	enterProjectName: 'Enter project name',
	projectName: 'Project name',
	projectStatus: 'Project status',
	financialCodes: 'Financial codes',
	noFinancialCodes: 'No financial engagement codes are mapped to this project',
	engagementCode: 'Engagement code',
	client: 'Client',
	status: 'Status',
	validatedBy: 'Validated by',
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: 'Members',
	gui: 'GUI',
	firstName: 'First name',
	lastName: 'Last name',
	emailAddress: 'Email address',
	userRole: 'User role',
	validated: 'Validated',
	unvalidated: 'Unvalidated',
	enterValidGui: 'Enter a valid GUI for project ID',
	requiredProjectName: 'Project name cannot be blank',
	successToastMessage: 'Changes saved successfully',
	resetToastMessage: 'Reset completed',
	errorToastMessage: 'At least one project member is required to be a Project administrator. Please review the changes.',
	independenceOnly: 'Independence only',
	yes: 'Yes',
	no: 'No'
};

export const manageAdministrators = {
	title: 'Manage administrators',
	firstName: 'First name',
	lastName: 'Last name',
	email: 'Email',
	role: 'Role',
	description: 'Add new administrators or manage existing administrators',
	noInformationPlaceholder: 'No information available for the selected options.',
	updateAdminErrorToast: 'Update was unsuccessful. Please review and try again later.',
	updateAdminSuccessToast: 'Changes saved successfully',
};

export const adminManageUsers = {
	title : 'Manage users',
	description: 'Search for a user by entering their user GUI',
	inputLabel: 'User GUI',
	searchButtonLabel: 'Search',
	cancelButtonLabel: 'Clear',
	errorMessage: 'Enter a valid user GUI',
	userDetails: 'User details',
	projects: 'Projects',
	delegates: 'Delegates',
	settings: 'Settings',
	noResultsPlaceholder: 'No records found',
	delegatedTo: 'Delegated to:',
	delegatedFrom: 'Delegated from:',
	gui: 'GUI',
	firstName: 'First name',
	lastName: 'Last name',
	emailAddress: 'Email address',
	projectName: 'Project name',
	projectId: 'Project ID'
};

export const adminCommon = {
	save: 'Save',
	reset: 'Reset'
}
